import { Component, OnInit } from '@angular/core';
import { SalesModuleApiSuffixModels } from '@app/modules';
import { CrudService, RxjsService } from '@app/shared/services';
import { IApplicationResponse, ModulesBasedApiSuffix, prepareRequiredHttpParams } from '@app/shared/utils';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/api';
@Component({
  selector: 'app-credit-vetting',
  templateUrl: './credit-vetting-modal.component.html',
})

export class CreditVettingModalComponent implements OnInit {
  creditVettingReport: any;
  listData: any;
  searchType = "";
  isFormSubmitted = false;
  data;

  constructor(private crudService: CrudService,
    private rxjsService: RxjsService, public ref: DynamicDialogRef, public config: DynamicDialogConfig) {
    this.data = config?.data;
    this.data['tradingNo'] = '';
  }

  selectedDebtor: any;
  select(e, i, dt) {
    this.selectedDebtor = dt;
    this.listData.forEach((element, index) => {
      if (index == i) {
        element.isChecked = true;
      } else {
        element.isChecked = false;
      }
    });
  }

  ngOnInit(): void {
    this.rxjsService.setDialogOpenProperty(true);
  }

  onSubmit() {
    this.ref.close(this.selectedDebtor)
  }

  getDetails() {
    this.isFormSubmitted = true;
    if ((!this.searchType && this.searchType !== 'TradingNo') || (!this.data.tradingNo && this.searchType == 'TradingNo')) {
      return;
    }
    this.crudService.get(ModulesBasedApiSuffix.CUSTOMER_MANAGEMENT, SalesModuleApiSuffixModels.VALIDATE_CUSTOMER, null, false,
      prepareRequiredHttpParams(
        {
          searchType: this.searchType,
          subjectName: this.searchType == 'Name' ? this.data.companyName : '',
          tradingNumber: this.searchType == 'TradingNo' ? this.data.tradingNo : '',
          registrationNo: this.searchType == 'RegNo' ? this.data.companyRegNo : '',
        }
      ))
      .subscribe((response: IApplicationResponse) => {
        if (response.resources && response.isSuccess && response.statusCode == 200) {
          this.listData = response.resources;
          this.listData.forEach(element => {
            element.isChecked = false;
          });
        }
      });
  }

  dialogClose() {
    this.ref.close(false);
  }

  ngOnDestroy(): void {
    this.rxjsService.setDialogOpenProperty(false);
  }
}